import { gql } from "@apollo/client";

export const CREATE_ASSISTANCE_PROGRAM = gql`
    mutation CreateProgram(
        $name: String!
        $idProgramSubtype: Int!
        $active: Boolean!
         ){
        createProgram(
            input: {
                name: $name
                idProgramSubtype: $idProgramSubtype
                active: $active
            }
        ) {
            idSubTipoPrograma
            nombre
        }
    }
`;